import React from 'react';
import { useIntl } from 'react-intl';
import { RichText } from 'volto-essvoltocomponents/components/Atoms';
import PageHeaderSimple from '../../Molecules/PageHeaderSimple';
import { ContentNarrow, ContentWide, PageSection, ContentWrapper } from 'volto-essvoltocomponents/components/Layout';
import { formatNewsDate } from '../../../helpers/multimediaUtils';  

const NewsItemESSView = ({ content }) => {
  const intl = useIntl();

  return (
    <>
      <PageHeaderSimple
        title={content.title}
        description={formatNewsDate(content.effective || content.EffectiveDate)}
        showBackButton={true}
        goBackText="Go back"
      />

      <PageSection paddingBottom="var(--ess-space-7xl)">
        <ContentWrapper>
          <ContentWide>
            <ContentNarrow gap="0">
              {/* Author */}
              {content?.creators && (
                <p className="author">By {content.creators[0]}</p>
              )}

              {/* Full Description */}
              {content?.full_description?.output && (
                <RichText
                  content={content.full_description.output}
                  className="news-full-description"
                />
              )}

              {/* Body */}
              {content?.body?.data && (
                <RichText content={content.body.data} className="news-body" />
              )}
            </ContentNarrow>
          </ContentWide>
        </ContentWrapper>
      </PageSection>
    </>
  );
};

export default NewsItemESSView;
